import { erpApi } from '@/shared/axios/erp-api';
import {
  getUrlParamsFetch,
  handleAxiosError,
  urlBackend,
  urlNapByCiudad,
} from '@/shared';
import {
  UseFetchEnabledParams,
} from '@/shared/interfaces';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { IDistancia, INapsPagingRes, Naps } from '@/shared/interfaces/erp/mantenimiento-operaciones';

type INapProps = {
  ciudad: string;
  sector?: number;
  page_size?: number;
};
const { get, post } = erpApi();

///* OBTENER NAP POR CIUDAD
export const useGetNap = ({ ciudad, page_size, sector }: INapProps) => {
  return useQuery({
    queryKey: ['nap', ciudad],
    queryFn: async () => {
      return getNap(ciudad, page_size, sector);
    },
  });
};

export const getNap = async (
  ciudad: string,
  page_size = 100,
  sector?: number,
  lat?: string,
  lng?: string
) => {
  const resp = await get<INapsPagingRes>(
    urlNapByCiudad(ciudad, page_size, sector, lat, lng),
    true
  );
  return resp.data.data;
};

//OBTENER DISTANCIA ENTRE USUARIO Y NAP

export const useDistanciaFetch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (distancia: IDistancia) => {
      return getDistanciaUserNap(distancia);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['distancia'] });
    },
    onError: (e) =>
      handleAxiosError(e)

  });
};

export const getDistanciaUserNap = async (distancia: IDistancia) => {
  const resp = await post<number>(`${urlBackend}api/v1/calcular-distancia/`, distancia, true);

  return resp;
};

//
export type GetNpasParams = Partial<Naps> & {
  page?: number;
  page_size?: number;

  // aux
  lat?: string;
  lng?: string;
};
export const getAllNaps = async (params?: GetNpasParams) => {
  const queryParams = getUrlParamsFetch(params ?? {});

  return get<INapsPagingRes>(`${urlBackend}api/v1/nap/?${queryParams}`, true);
};

export const useFetchAllNaps = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<GetNpasParams>) => {
  return useQuery({
    queryKey: ['naps', params],
    queryFn: async () => {
      return getAllNaps(params);
    },
    enabled: enabled,
  });
};



const PAGE_SIZE = 20;
export const fetchPageNaps = async (query: string, page: number, params: any) => {
  try {
    const res = await getAllNaps({
      ...params,
      nombre: query,
      page,
      page_size: PAGE_SIZE,
    });
    const items = res.data.data;
    const total = res.data?.count ?? 0;

    const options: string[] = items
      .map(x => x.nombre)
      .filter((s: unknown): s is string => typeof s === "string")

    const hasMore = (page * PAGE_SIZE < total);

    return { options, hasMore };
  } catch (err) {
    // En caso de error, no cortes el scroll del usuario
    console.error("fetchPageSeries error:", err);
    return { options: [] as string[], hasMore: false };
  }
};